import { refresh } from "../api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refreshToken = async () => {
    
    const res = await refresh(); // { results: { accessToken, profile_id } }
    const newAccessToken = res?.results?.accessToken;
    const profile_id = res?.results?.profile_id;

    if (!newAccessToken) {
      throw new Error("No accessToken in refresh response");
    }

    setAuth((prev) => ({
      ...prev,
      profile_id,
      accessToken: newAccessToken,
    }));

    return newAccessToken;
  };

  return refreshToken;
};

export default useRefreshToken;
